import { connect } from 'react-redux';
import { Row, Col, InputGroup, Panel, SplitButton, MenuItem, Form, Glyphicon } from 'react-bootstrap';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import FilterSearchForm from './FilterSearchForm';
import LoadClientDialog from './LoadClientDialog';
import Button from './Button';
import TextInput from './TextInput';
import { casesRefreshNeededAction,
         casesFilterAction,
         caseNewForClientAction } from '../../actions/caseActions';

import { clientsRefreshNeededAction,
         clientsFilterAction } from '../../actions/clientActions';

import { parseFilterFromQuery, filteredRoute, findBootstrapEnvironment } from '../../helpers/utils';
import SendEmailForm, { isEmailIntegrated } from './SendEmailForm';
import SendSmsForm, { isSmsIntegrated } from './SendSmsForm';
import { isDemoAccount } from './../../helpers/utils';

export const navigateToCases = (selectedState = undefined, state = undefined) => {
    let filterObj = {
        query: undefined,
        filters: undefined,
    };

    if (state && state !== selectedState) {
        filterObj = {
            query: '',
            filters: {
                filters: [
                    {
                        left: 'notes.CaseState',
                        right: state,
                        operator: '=',
                    },
                ],
                archived: false,
                type: 'and',
            },
            hideFilterPanel: state,
        };
    }

    if (state && state === selectedState) {
        filterObj = { hideFilterPanel: true };
    }

    return filterObj;
};


export const navigateToClients = (selectedState = undefined, state = undefined) => {
    let filterObj = {
        query: undefined,
        filters: undefined,
    };

    if (state && state !== selectedState) {
        filterObj = {
            query: '',
            filters: {
                filters: [
                    {
                        left: 'client.ClientType',
                        right: state,
                        operator: '=',
                    },
                ],
                archived: false,
                type: 'and',
            },
            hideFilterPanel: state,
        };
    }

    if (state && state === selectedState) {
        filterObj = { hideFilterPanel: true };
    }

    return filterObj;
};

class SearchForm extends PureComponent {
    constructor(props) {
        super(props);
        this.search = this.search.bind(this);
        this.searchWithDelay = this.searchWithDelay.bind(this);
        this.newRecord = this.newRecord.bind(this);
        this.newRecordFromClient = this.newRecordFromClient.bind(this);
        this.state = {
            loadClientDialogOpen: false,
            sendEmailDialogOpen: false,
            sendSmsDialogOpen: false,
            filters: undefined,
            queryFilters: undefined,
            search: undefined,
        };
    }

    componentDidMount() {
        if (this.props.customSearch) {
            this.props.customSearch({});
        }

        let search = this.state.search;
        if (search === undefined) {
            search = this.props.search;
        }

        let filters = this.state.filters;
        if (filters === undefined) {
            filters = this.props.filters && this.props.filters.filters;
        }

        this.setState({ search, filters });
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.config) {
            return;
        }

        let filters = parseFilterFromQuery(nextProps.filter, nextProps.archived, nextProps.config, this.props.recordType === 'case' ? 'matter' : 'client');
        let search = this.state.search;
        let hideFilterPanel = nextProps.hideFilterPanel;
        let refresh = false;
        let newState = { filters };
        
        // Set proper search text input
        if (search === undefined) {
            newState.search = nextProps.search;
            search = nextProps.search;
            if ((search || '') !== (this.props.search || '')) {
                refresh = true;
            }
        }

        // Full reload on Logo click
        if (filters === undefined &&
            nextProps.search === undefined &&
            nextProps.search !== this.props.search) {

            search = undefined;
            filters = undefined;
            refresh = true;
            hideFilterPanel = true;
            newState = {
                search: '',
                filters: undefined,
            };
        }

        this.setState(newState);
        if (refresh || !_.isEqual(this.props.filters && this.props.filters.filters, filters)) {
            if (this.props.customSearch) {
                this.props.customSearch({ query: search, filters, hideFilterPanel });
            } else {
                this.search(hideFilterPanel, { query: search, filters });
            }
        }
    }

    searchWithDelay(timeout=500) {
        if (this.saveTimeoutId) {
            clearTimeout(this.saveTimeoutId);
            this.saveTimeoutId = undefined;
        }

        this.saveTimeoutId = setTimeout(() => {
            this.saveTimeoutId = undefined;
            this.search(this.props.hideFilterPanel);
        }, timeout);
    }

    search(hideFilterPanel=false, overridenfilterObj=undefined) {
        let query = this.state.search;
        if (!query) {
            query = '';
        }

        const filters = this.state.filters;
        const filterObj = overridenfilterObj || { query, filters };
        filterObj.hideFilterPanel = hideFilterPanel;
        let route;
        const location = window.history.location || window.location; // Use history hashbang fallback if Office.js is used.
        if (this.props.customSearch) {
            this.props.customSearch(filterObj);
            return;
        }

        switch (this.props.recordType) {
            case 'case':
                route = filteredRoute('/case/all', filterObj);
                this.props.dispatch(casesFilterAction(filterObj));
                browserHistory.push(route);
                this.props.dispatch(casesRefreshNeededAction(true));
                break;

            case 'client':
                route = filteredRoute('/client/all', filterObj);
                this.props.dispatch(clientsFilterAction(filterObj));
                browserHistory.push(route);
                this.props.dispatch(clientsRefreshNeededAction(true));
                break;

            // Office.js / Word addin
            case 'word':
                route = filteredRoute('/word', filterObj);
                this.props.dispatch(casesFilterAction(filterObj));
                //browserHistory.push(route);
                this.props.dispatch(casesRefreshNeededAction(true));
                break;
        }
            
        this.forceUpdate();
    }

    newRecord(evt) {
        switch (this.props.recordType) {
            case 'case':
                browserHistory.push('/case/new');
                break;

            case 'client':
                browserHistory.push('/client/new');
                break;

            default:
                break;
        }
    }

    newRecordFromClient(index, row) {
        this.props.dispatch(caseNewForClientAction(row.client));
        this.newRecord();
    }

    render() {
        const {
            submitting,
            hideAdvancedSearch,
            hideNewRecord,
            loggedIn
        } = this.props;

        let searchBtnNo = 1;
        if (hideAdvancedSearch) {
            searchBtnNo = 0;
        }

        const size = findBootstrapEnvironment();
        let newRecordButton;
        if (!hideNewRecord) {
            switch (this.props.recordType) {
                case 'case':
                    newRecordButton = (
                        <div id="tour-new-case">
                        <SplitButton title={(<span><Glyphicon glyph="file"/> New Case ... </span>)}
                                     bsStyle="primary"
                                     data-hj-whitelist
                                     id="tour-new-case-client"
                                     onClick={this.newRecord}
                        >
                        <MenuItem data-hj-whitelist onClick={() => this.setState({loadClientDialogOpen: true})}>From Existing Client ...</MenuItem>
                        <MenuItem data-hj-whitelist onClick={() => this.setState({sendEmailDialogOpen: true})} disabled={!isEmailIntegrated(loggedIn)}>Email Intake Form ...</MenuItem>
                        <MenuItem data-hj-whitelist onClick={() => this.setState({sendSmsDialogOpen: true})} disabled={!isSmsIntegrated(loggedIn) || isDemoAccount(loggedIn)}>SMS Intake Form ...</MenuItem>
                        </SplitButton>
                        </div>
                    );
                    break;

                case 'client':
                    newRecordButton = (
                        <Button onClick={this.newRecord}
                                disabled={submitting}
                                icon="file"
                                style={{ width: 160 }}
                                bsStyle="primary"
                                label="New Contact ..."
                                tooltip="Create new record"
                                tooltipPosition="bottom"
                        />);
                    break;

                default:
                    break;
            }
        }

        let searchBar = (
            <TextInput field={{
                            name: 'search',
                            value: this.state.search,
                            touched: true,
                        }}
                        name="search"
                        inputStyle={{ minWidth: 200, marginTop: size !== 'xs' ? 0 : 15 }}
                        plainInput
                        onChange={(evt) => {
                            this.setState({ search : evt.target.value }, () => {
                                if (this.state.filters === undefined || this.props.hideFilterPanel) {
                                    this.searchWithDelay();
                                }
                            })
                        }}
                        placeholder="Search ..."
                        onKeyPress={(evt) => {
                            const key = evt.which || evt.keyCode;                          
                            if (key === 13) {
                                if (this.saveTimeoutId) {
                                    clearTimeout(this.saveTimeoutId);
                                    this.saveTimeoutId = undefined;
                                }

                                evt.preventDefault();                                      
                                this.search();
                            }
                        }}
            />
        );

        const active = this.props.hideFilterPanel !== undefined && !this.props.hideFilterPanel;
        if (!hideAdvancedSearch) {
            let label = "[+]";
            if (active) {
                label = "[-]";
            }

            searchBar = (
                <InputGroup id="tour-cases-search">
                    {searchBar}
                    <InputGroup.Button>
                    <Button disabled={submitting}
                            bsStyle="link"
                            onClick={(evt) => {
                                evt.preventDefault();
                                if (active) {
                                    this.search(true, { filters: undefined, query: this.state.search });
                                } else {
                                    this.search(false, { filters: this.state.filters, query: this.state.search });
                                }
                            }}
                            active={active}
                            icon="filter"
                            label={label}
                            tooltip="Narrow searching criteria by adding filters"
                            tooltipPosition="bottom"
                            style={{ float: 'right', width: 70 }}
                            id="tour-cases-search-advanced"
                    />
                    </InputGroup.Button>
                </InputGroup>
            );
        }

        return (
            <Row>
            <Form>
                {!hideNewRecord && (
                <Col xs={3} md={3} lg={1} style={{minWidth: '185px'}}>
                {newRecordButton}
                </Col>)}
                <Col xs={8} md={8} lg={9} style={{ marginBottom: 15 }}>
                {searchBar}
                </Col>
                {newRecordButton && (
                <div>
                <LoadClientDialog
                    selectRow={this.newRecordFromClient}
                    cancel={() => this.setState({ loadClientDialogOpen: false })}
                    open={this.state.loadClientDialogOpen}
                />
                <SendEmailForm showAsDialog
                               templatesFieldName="publicIntakeEmailTemplates"
                               enableAddTemplate={false}
                               enableEditTemplate={false}
                               renderTemplateLoad={false}
                               renderEmailSection
                               renderEmailButton
                               disableCaseFilesAutoload
                               renderAttachmentField={false}
                               currentCase={{empty: true}}
                               onEmailSent={() => this.setState({ sendEmailDialogOpen: false })}
                               cancel={() => this.setState({ sendEmailDialogOpen: false })}
                               open={this.state.sendEmailDialogOpen}
                               title="Email Intake Form"
                />
                <SendSmsForm showAsDialog
                             templatesFieldName="publicIntakeSmsTemplates"
                             enableAddTemplate={false}
                             enableEditTemplate={false}
                             onSent={() => this.setState({ sendSmsDialogOpen: false })}
                             cancel={() => this.setState({ sendSmsDialogOpen: false })}
                             onSmsSent={() => this.setState({ sendSmsDialogOpen: false })}
                             open={this.state.sendSmsDialogOpen}
                             currentCase={{empty: true}}
                             title="SMS Intake Form"
                />
                </div>)}
                {active && (
                <Row style={{marginLeft: 0, marginRight: 0}}>
                <Col xs={12}>
                <Panel style={{marginTop: '-15px'}}>
                    <FilterSearchForm filters={this.state.filters}
                                      recordType={this.props.recordType}
                                      queryFilters={this.state.queryFilters}
                                      loading={submitting}
                                      onChange={(filters) => {
                                           this.setState({ filters });
                                      }}
                                      onSearch={() => { this.search(false); }}
                                      configFilterName={`${this.props.recordType}Filters`}
                    />
                </Panel>
                </Col>
                </Row>)}
            </Form>
            </Row>
        );
    }
}

SearchForm.propTypes = {
    submitting: PropTypes.bool,
    hideAdvancedSearch: PropTypes.bool,
    recordType: PropTypes.string.isRequired,
    newRecordFromTemplateLabel: PropTypes.string,
    query: PropTypes.any,
    customSearch: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {
    let filters;
    const query = ownProps.query || state.routing.locationBeforeTransitions.query;
    if (state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.pathname.startsWith('/case')) {
        filters = state.cases.filter;
    } else if (state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.pathname.startsWith('/client')) {
        filters = state.clients.filter;
    }

    let archived = query.a;
    if (archived === 'true') {
        archived = true;
    } else {
        archived = false;
    }

    let hideFilterPanel = query.hideFilterPanel;
    if (hideFilterPanel === "true") {
        hideFilterPanel = true;
    } else if (hideFilterPanel === "false") {
        hideFilterPanel = false;
    } else if (!hideFilterPanel) {
        hideFilterPanel = true;
    }

    return {
        search: query.q,
        filter: query.f,
        hideFilterPanel,
        archived,
        config: state.user.config,
        filters,
        loggedIn: state.user.loggedIn
    };
};

export default connect(mapStateToProps)(SearchForm);

